<template>
  <b-row>
    <b-col cols="12">
      <user-stats-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import UserStatsContent from './UserStatsContent.vue'

export default {
  components: {
    BRow,
    BCol,

    UserStatsContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>